import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../../../../components/shared/custom-components/Loader';
import DefiDashboard from '../../../../../../../../../components/source-management/wallets/wallet-page/defi-dashboard/DefiDashboard';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/defi',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: DefiDashboard,
});
